/**
 * Types + fetchers for GET / PATCH /api/v1/me.
 *
 * Types come from the OpenAPI-generated schema in `_generated/schema.d.ts`.
 * Regenerate via `pnpm gen:api` after a backend Pydantic change.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type Grant = components["schemas"]["daquma__api__v1__me__GrantOut"];
export type Me = components["schemas"]["MeOut"];
export type MePatchInput = components["schemas"]["MePatch"];

export function getMe(accessToken: string): Promise<Me> {
  return apiFetch<Me>("/api/v1/me", { token: accessToken });
}

export function patchMe(token: string, input: MePatchInput): Promise<Me> {
  return apiFetch<Me>("/api/v1/me", { method: "PATCH", token, json: input });
}
